import {
  setValueAction,
  ValueFeature as valueReducer,
  ValuePayload,
} from '@smartsheet-dataflow/formjs';
import { BridgeFormJSState } from '../../Types';
import { dummyDispatch } from '../ParamFromSchema';

export const reduceValue =
  (payload: ValuePayload) => (state: BridgeFormJSState) =>
    valueReducer(state, setValueAction(dummyDispatch)(payload));
